export const Routes = {
    main: "/",
    signIn: "/signin",
    forgotPassword: "/forgot-password",
    oneTimePassword: "/one-time-password",
    monthlyReport: "/monthly-report",
    accounts: "/accounts",
    salaries: "/salaries",
    salariesFullScreen: "/salaries-full-screen",
    salaryActions: "/salary-actions",
    emailTrackingReport: "/email-tracking-report",
    authHistory: "/auth-history",
    generalDocuments: "/general-documents",
    invoiceRequest: "/invoice-request",
    expenseRequest: "/expense-request",
    serviceCall: "/service-call",
    myRequests: "/my-requests",
}